import { Button } from "@mui/material"
import { OptionsObject, SnackbarMessage, useSnackbar } from "notistack"
import React from "react"

export interface SnackbarButton {
  label: string
  handleOnClick: (key: string) => void
}

export enum SnackbarVariant {
  Success = "success",
  Error = "error",
  Warning = "warning",
}

export interface SnackbarProps extends OptionsObject {
  label?: string
  persist?: boolean
  variant?: SnackbarVariant
  snackbarButtons?: SnackbarButton[]
}

export const useAlert = () => {
  const { enqueueSnackbar } = useSnackbar()
  return (label: SnackbarMessage, options: SnackbarProps = {}) => {
    const { snackbarButtons, variant, persist = false, ...others } = options

    // Create the actions buttons if it's existing
    const action = (key: string) => (
      <>
        {snackbarButtons?.map((snackbarAction, index) => (
          <Button key={index} color="inherit" onClick={() => snackbarAction.handleOnClick(key)}>
            {snackbarAction.label}
          </Button>
        ))}
      </>
    )

    return enqueueSnackbar(label, { variant: variant, persist: persist, ...others, action })
  }
}
